import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './shadcn/select';
import { PracticeArea, PRACTICE_AREA_LABELS } from '../../../../backend/src/user/practice-area';

export function PracticeAreaSelect({
  value,
  onValueChange,
  disabled,
  className,
  id,
}: {
  value: PracticeArea | null;
  onValueChange: (value: PracticeArea) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}) {
  return (
    <Select
      value={value ?? undefined}
      onValueChange={(newValue) => onValueChange(newValue as PracticeArea)}
      disabled={disabled}
    >
      <SelectTrigger id={id} className={className}>
        <SelectValue placeholder="Not set" />
      </SelectTrigger>
      <SelectContent>
        {Object.values(PracticeArea).map((practiceArea) => (
          <SelectItem key={practiceArea} value={practiceArea}>
            {PRACTICE_AREA_LABELS[practiceArea]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
